import { render, staticRenderFns } from "./ImportProdutosASilenciar.vue?vue&type=template&id=04779eb4"
import script from "./ImportProdutosASilenciar.vue?vue&type=script&lang=js"
export * from "./ImportProdutosASilenciar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports